import { render, staticRenderFns } from "./admin-followup.vue?vue&type=template&id=15470249"
import script from "./admin-followup.vue?vue&type=script&lang=js"
export * from "./admin-followup.vue?vue&type=script&lang=js"
import style0 from "./admin-followup.vue?vue&type=style&index=0&id=15470249&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports